import React, { useRef, useState } from "react";
import { MdEmail } from "react-icons/md";
import { auth } from "../../Firebase";
import { useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import LeadRubixLogo from "../../Assets/Images/leadrubixlogoone.svg";
import { Circles } from "react-loader-spinner";
import { Box, Paper, Typography, InputAdornment } from "@mui/material";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: 12,
    backgroundColor: "#f7f8fa",
    fontSize: "var(--font-size-large)",
    fontFamily: "var(--font-family-main)",
    "& fieldset": {
      borderColor: "#bfc7d5",
    },
    "&:hover fieldset": {
      borderColor: "#292744",
      border: `1.5px solid #292744`
    },
    "&.Mui-focused fieldset": {
      borderColor: "#292744",
      border: `1.5px solid #292744`
    },
  },
  "& .MuiInputBase-input": {
    padding: "14px",
    fontSize: 16,
    color: "#222",
  },
  "& .MuiInputLabel-root": {
    fontWeight: 500,
    fontSize: 15,
    color: "#292744",
  },
});

const ForgotPassword = (props: any) => {
  const emailRef: any = useRef();
  const dispatcher = useDispatch();
  const [load, setLoad] = useState(false);

  const send = async (email: string) => {
    if (email !== "") {
      try {
        if (email) {
          setLoad(true);
          await auth.sendPasswordResetEmail(email);
          setLoad(false);
          dispatcher(
            showSnackbarAction(
              "Password reset information have been sent on you registered email id",
              "success"
            )
          );
          props.history.push("/");
        }
      } catch (error) {
        setLoad(false);
        dispatcher(showSnackbarAction("Failed to send reset email. Please try again.", "error"));
      }
    } else {
      dispatcher(showSnackbarAction("Please Enter Your Email!", "error"));
    }
  };

  return (
    <>
      <Box
        style={{
          minHeight: "100vh",
          width: "100vw",
          background: "linear-gradient(135deg, rgb(255,250,250) 0%, #e0e7ff 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "var(--font-family-main)",
        }}
      >
        <Paper
          sx={{
            width: 400,
            background: "#fff",
            borderRadius: 5,
            boxShadow: "0 8px 40px rgba(0,0,0,0.10)",
            padding: "32px 36px 36px 36px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transition: "box-shadow 0.2s",
          }}
        >
          <img
            src={LeadRubixLogo}
            alt="LeadsRubix"
            style={{
              width: 170,
              marginBottom: 18,
            }}
          />
          <Typography
            variant="h5"
            sx={{
              fontFamily: "var(--font-family-main)",
              fontWeight: 700,
              fontSize: "var(--font-size-large)",
              mb: 1,
              color: "#292744",
              textAlign: "center",
            }}
          >
            Forgot Password?
          </Typography>
          <Typography
            sx={{
              fontSize: "var(--font-size-medium)",
              mt: 0,
              mb: 3,
              color: "#555",
              textAlign: "center",
              fontFamily: "var(--font-family-main)",
            }}
          >
            Enter your registered email below to receive password reset instructions
          </Typography>
          <Box sx={{ width: "100%", mb: 2 }}>
            <CustomTextField
              inputRef={emailRef}
              label="Email address"
              type="email"
              fullWidth
              required
              variant="outlined"
              placeholder="Enter your email"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MdEmail style={{ color: "#9ca3af", fontSize: 20 }} />
                  </InputAdornment>
                ),
                style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }
              }}
              InputLabelProps={{ style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
              onKeyDown={e => {
                if (e.key === "Enter") {
                  send(emailRef.current?.value);
                }
              }}
            />
          </Box>
          <button
            style={{
              width: "100%",
              background: "linear-gradient(90deg, #292744 0%, #292744 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 10,
              padding: "14px 0",
              fontSize: "var(--font-size-large)",
              marginTop: 8,
              marginBottom: 8,
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(41,39,68,0.10)",
              fontFamily: "var(--font-family-main)",
              transition: "background 0.2s, box-shadow 0.2s",
              fontWeight: 600,
            }}
            onMouseOver={e => e.currentTarget.style.background = "linear-gradient(90deg, #292744 0%, #292744 100%)"}
            onMouseOut={e => e.currentTarget.style.background = "linear-gradient(90deg, #292744 0%, #292744 100%)"}
            onClick={() => send(emailRef.current?.value)}
            disabled={load}
          >
            {load ? (
              <span style={{ display: "flex", justifyContent: "center" }}>
                <Circles color="#fff" height={20} width={20} />
              </span>
            ) : (
              "Send"
            )}
          </button>
          <div
            style={{
              marginTop: 8,
              fontSize: "var(--font-size-medium)",
              color: "#555",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              whiteSpace: "nowrap",
              fontFamily: "var(--font-family-main)",
              cursor: "pointer",
            }}
            onClick={() => props.history.push("/")}
          >
            Remember Password?
            <span
              style={{
                color: "#292744",
                marginLeft: 4,
                fontWeight: 500,
                textDecoration: "underline"
              }}
            >
              Login
            </span>
          </div>
        </Paper>
      </Box>
    </>
  );
};

export default ForgotPassword;
